import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthRouter from './routers/AuthRouter';
import AuthProvider from './context/auth/AuthProvider'
import PrivateAdminRouter from './routers/PrivateAdminRouter';
import AdminRouter from './routers/AdminRouter';
import PrivateCandidateRouter from './routers/PrivateCandidateRouter';
import CandidateRouter from './routers/CandidateRouter';
import PrivateSchoolRouter from './routers/PrivateSchoolRouter';
import SchoolRouter from './routers/SchoolRouter';
import MultiSchoolRouter from './routers/MultiSchoolRouter';
import PrivateMultiSchoolRouter from './routers/PrivateMultiSchoolRouter';

export default function App() {

  return (
    <>
      <BrowserRouter>
        <AuthProvider>    
          <Routes>
              <Route path="/admin/*" element={ <PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
              <Route path="/candidate/*" element={ <PrivateCandidateRouter><CandidateRouter /></PrivateCandidateRouter>} />
              <Route path="/school/*" element={ <PrivateSchoolRouter><SchoolRouter /></PrivateSchoolRouter>} />
              <Route path="/multischool/*" element={ <PrivateMultiSchoolRouter><MultiSchoolRouter /></PrivateMultiSchoolRouter>} />
              <Route path="*" element={<AuthRouter />}/>
          </Routes>
        </AuthProvider>    
      </BrowserRouter>
    </>
  )
}
